export default {
      fr: {
            Global: {
                  continue: 'Continue',      
                  join: 'En savoir plus',  
                  title: "Lorem ipsum",
                  desc: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.",   
                  rules: "Règles du jeu",
                  copied: "a été copié dans le",
                  clipboard: "press-papier",
                  game_board: "Le jeu de plateau",
                  play_rugby: "où l’on joue au rugby",
                  now: "est disponible sur",
                  drop: "Le Drop",
                  conversion: "La Transformation",
                  forwards: "Combinaison d'avants",
                  backs: "Combinaison d'arrières",
                  halfbacks: "Jouer avec la charnière",
            },

            Game : {
                  title: "Le Jeu",
                  desc: "RWG est un jeu de plateau basé sur les règlements généraux du rugby. On y déplace le ballon pour marquer des points pendant que l'adversaire essaye de le récupérer et empêcher sa progression.</br></br><span class='rwg'>Chacune des équipes dispose d’un dé et 22 cartes pour exécuter des actions. Super simple!</span></br></br>Ensuite il suffit de lancer les dés et d'avoir une bonne connaissance des stratégies possibles. Consulte bien les règles du jeu pour comprendre toutes ses finesses, les situations de jeu sont innombrables.",
            },

            Dices : {
                  title: "Les Dés",
                  desc: "Ils servent à calculer la distance, la force, la précision d’une action ou le résultat d'un duel. Mis en commun, ils définissent la zone d'un ruck ou la difficulté d'une transformation puis un double donne toujours un résultat favorable.",
            },

            Cards : {
                  title: "Les Cartes",
                  desc: "Elles représentent les joueurs d'une équipe et sont numérotées de 1 à 15. On y retrouve donc plusieurs numéros identiques afin de multiplier les possibilités de combinaisons puis on utilise leurs attributs pour appeler des actions. Il est possible de les jouer seules ou combinées.</br></br>Concernant les attributs, certains sont communs à toutes les cartes, comme le Plaquage ou la Percussion, tandis que la Course est réservée aux numéros 6 à 15, le Jeu au pied dès le numéro 9 ou encore le Pick and Go uniquement aux cinq de devant, par exemple.</br></br>Aussi, à chaque tour de jeu, une équipe exécute une action, celles-ci varient selon les cartes en main et le numéro du joueur, la position du ballon et l'action précédente. Certaines demandent d'ajouter une ou plusieurs cartes, d'autres pas.",
            },

            Keys : {
                  title: "Points forts",
                  desc: "3 points forts sont attribués à chacune des équipes avant chaque partie. Un joueur et deux actions. On perd un point fort toutes les 3 fautes et lorsqu'on l’utilise, le coup de dé sera toujours 4, 5 ou 6.",
            },

            Community : {
                  title: "La Communauté",
                  desc: "RWG s'adresse à tous les passionnés de rugby, sans limite d’âge ni distinctions particulières autre que la compréhension des règles élémentaires du jeu.</br></br><span class='rwg'>Acquérir l’application, c’est aussi s’engager à respecter la différence de l’autre et les valeurs de chacun.</span></br></br>Il te faudra ensuite, créer ton équipe, choisir le nom qui te rendra célèbre dans notre communauté et un pays parmis les 25 plus grandes nations du rugby mondial.",
                  suite: "Tu y trouveras une compilation de tes meilleurs résultats, ainsi que les les statistiques de ton équipe. Tu auras la possibilité de défier notre équipe, subtile mélange de pragmatisme et de jeu total, pour une partie en solo ou encore affronter un membre de la communauté en temps réel."
            },

            Combine : {
                  title: "Comment combiner?",
                  desc: "Considère deux groupes de joueurs composés d’un leader et une charnière 9-10 chargée de faire la liaison entre ces groupes.</br></br><span class='rwg'>C'est facile!</span></br></br>Le leader du groupe d’avants est le numéro 9, celui des arrières le numéro 10.</br></br>Le leader débutera la combinaison de son groupe. Les joueurs seront obligés de passer la balle à un joueur du même groupe et le leader, tout comme la charnière, pourra s'intercaler à tout moment dans celle-ci.",
            },

            Data : {
                  title: "Données Personnelles",
                  desc: "RWG ne collecte aucune donnée personnelle, nul besoin de te connecter avec un profil quelconque, ton identifiant indiqué lors de la création de ton équipe sera la seule indication que nous connaîtrons.</br></br>Note aussi que pour cette raison, le seul moyen d'accéder à ton équipe sera l'application installée sur ton appareil.",
            },

            About : {
                  title: "À propos",
                  desc: "<span class='rwg'>Bienvenue dans l'univers de Rugby World Game, le jeu ou l’on joue au rugby créé par la Compagnie Blasco.</span></br></br>L’équipe locale donne le coup d'envoi. Double 2, elle s’impose dans les airs et récupère la balle à 30 mètres de la ligne adverse. S'ensuit un Jeu libre, une combinaison magnifique, 9 - 10 - 12 avec remise intérieure pour l’allier intercalé.</br></br>Repris sur la ligne d’en-but, mais conservant la possession de la balle après une bataille féroce aux abords du ruck, les locaux, par l'entremise de leurs avants, traversent la ligne et marque le premier essai d’une partie commencée tambours battants…</br></br>Munis d’un dé et de 22 cartes numérotées de 1 à 15, vous reproduirez toutes les actions qui font du rugby notre passion. De la simple course aux plaquages, du jeu au pied à l'interception, des mauls aux pick and go, des zones de ruck aux inévitables pénalités, de la communication entre la charnière 9-10 aux lancements de jeu, les situations sont innombrables.</br></br>Conçu pour des joueurs de tout âge et de tout niveau, <span class='rwg'>Rugby World Game</span> est une expérience certifiée, résultat d’heures de plaisir à partager notre idée du rugby, une synthèse d’émotions qui s’adresse à tous les passionnés de rugby sans distinctions particulières, respectueux de la différence de l’autre et des valeurs de chacun."
            },

            Policy : {
                  title: "Politique de confidentialité",
                  desc: "Fournie par la Compagnie Blasco, l'application Rugby World Game est destinée à être utilisée telle quelle. Toutes les données collectées dans l'application resteront sur l'appareil sur lequel elle a été créée, sauf si l'utilisateur les a explicitement partagées lui-même.</br></br>Si vous avez des questions, veuillez nous contacter par e-mail à info@rugbyworldgame.com."
            },

            Knowledge: {
                  title: "Les fondamentaux",
                  desc: "Ici, on explique l’essentiel. Il est conseillé d’en prendre connaissance avant de lire les Règles du jeu."
            },

            Results : {
                  title: "Résultats des matchs",
                  desc: "Voici les listes des matchs partagés par la communauté. Nous nous servons également de cette liste pour départager les meilleurs d’entre nous. Libre à toi de concourir.",
            },

            Training : {
                  title: "Camp d'entrainement",
                  desc: "Si l'entraînement est la clé du succès, consulte les rubriques de cette page, elles contiennent des mises en situation que tu devrais comprendre facilement.",
            },

            Price : {
                  title: "Ce n'est pas gratuit",
                  desc: "<span class='rwg'>Nous avons fait le choix de rendre cette application payante pour des raisons assez évidentes.</span></br></br>En contrepartie, tu n’y trouveras aucune publicité et l’application n’a pas de date d’expiration.</br></br>Nous savons également que même si le prix proposé est relativement abordable, certaines personnes pourraient avoir des problèmes pour s’en acquitter. Si cela est ton cas et que tu désires rejoindre la communauté, prends contact avec nous.",
            },

            URL: {
                  how: "comment-jouer",
                  hinge: "charniere-9-10", 
                  starter: "relayeur", 
                  attributs: "attributs",
                  duration: "duree", 
                  pro_mode: "mode-de-jeu",
                  dices: "des", 
                  cards: "cartes", 
                  actions: "actions", 
                  combine: "combinaisons-de-jeu", 
                  duel: "duel",
                  teams: "composition-equipe", 
                  keys: "points-forts",
                  fouls: "fautes", 
                  twenty_two: "zone-des-22-metres", 
                  bonus: "bonus", 
                  kickoff: "kickoff", 
                  counterattack: "relance", 
                  tackle: "plaquage", 
                  interception: "interception", 
                  free_play: "jeu-libre",
                  ruck: "ruck", 
                  contest: "conteste",
                  relay: "regroupement", 
                  pickandgo: "pick-and-go", 
                  no_contest: "no-contest",
                  lineout: "touche", 
                  maul: "maul",
                  scrum: "melee", 
                  knock_on: "en-avant", 
                  penalty: "penalite",
                  choice_hands: "jeu-a-la-main",
                  advantage: "retour-a-la-penalite", 
                  choice_lineout: "penaltouche", 
                  run: "course", 
                  carry: "percussion", 
                  kick: "coup-de-pied", 
                  drop: "drop-goal",  
                  try: "essai", 
                  conversion: "transformation", 
                  find_lineout: "degagement-en-touche",
                  twenty_two_drop_out: "renvoi-aux-22-metres",
                  offside: "hors-jeu"
            },

            Navigation: {
                  rules: "Règles du jeu",
                  about: "À propos",
                  contact: "Contacts",
                  knowledge: "Les fondamentaux",
                  results: "Résultats",
                  training: "Entrainement",
            }
      },
      en: {
            Global: {
                  continue: 'Continue',   
                  test: 'Try it',      
                  relay: 'Relay', 
                  drop: 'Drop Kick', 
                  join: 'Read more',  
                  title: "Lorem ipsum",
                  desc: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.",
                  rules: "Game rules",
                  copied: "was copied to",  
                  clipboard: "clipboard",
                  game_board: "The gameboard",
                  play_rugby: "where you play rugby",   
                  now: "is available on",
                  drop: "Drop Goal",
                  conversion: "Conversion",
                  forwards: "Combine with Forwards",
                  backs: "Combine with Backs",
                  halfbacks: "Play with Half-backs",
            },

            Game : {
                  title: "The Game",
                  desc: "RWG is a board game based on general rugby rules. The ball is moved to score points while the opponent tries to recover the ball and prevent its progress.</br></br><span class='rwg'>Each team has a die, 22 cards and 3 strengths to perform actions.</span></br></br>Be sure to read the rules of the game to understand all its subtleties, the game situations are endless.",
            },

            Dices : {
                  title: "The Dice",
                  desc: "They are used to calculate the distance, strength, accuracy of an action or the result of a duel. Together, they define the area of a ruck or the difficulty of a conversion. A double always gives a favorable result.",
            },

            Cards : {
                  title: "The Cards",
                  desc: "They represent the players of a team and are numbered from 1 to 15. They can be played alone or combined. There are several identical numbers in order to multiply the possibilities of combinations and we use their attributes to call actions.</br></br>As for attributes, some are common to all cards, such as tackling or carrying, while running, for example, will be reserved for numbers 6 to 15.</br></br>Also, in each round of the game, a team performs an action. This varies according to the cards in hand, the position of the ball and the previous action. Some require the addition of one or more cards, others do not.",
            },

            Keys : {
                  title: "Keys strength",
                  desc: "Each team is given 3 strengths before each game: one player and two actions. When used, the value of the dice roll will always be 4, 5 or 6. Every three penalties results in the loss of a key strength.",
            },

            Community : {
                  title: "The Community",
                  desc: "RWG is for all rugby enthusiasts, with no age limit or particular distinctions other than an understanding of the basic rules of the game.</br></br><span class='rwg'>Acquiring the application is also a commitment to respect each other's differences and values.</span></br></br>You will then have to create your team, choose the name that will make you famous in our community and a country among the 25 greatest nations of world rugby.",
                  suite: "You will find a compilation of your best results and your team's statistics. You will have the possibility to challenge our team, a subtle mix of pragmatism and total game, for a solo game or a face to face against a member of the community, in real time."
            },

            Combine : {
                  title: "How to combine?",
                  desc: "Consider two groups of players consisting of a leader and halfbacks responsible for linking these groups.</br></br><span class='rwg'>It's easy!</span></br></br>The leader of the forward group is number 9, the backs number 10.</br></br>The leader will start the combination of his group. The players will be obliged to pass the ball to a player of the same group and the leader, like half-backs, will be able to step into it at any time.",
            },

            Data : {
                  title: "Personal data",
                  desc: "<span class='rwg'>RWG doesn't collect any personal data, no need to log in with any profile.</span></br></br>Your username given when creating your team will be the only information we will know. For this reason, the only way to access your team will be through the application installed on your device.",
            },

            About : {
                  title: "About",
                  desc: "<span class='rwg'>Welcome to the world of Rugby World Game, the game where you play rugby created by the Compagnie Blasco.</span></br></br>The home team kicks off. Double 2, it recovers the ball in the air and has possession 30 meters away from the opposition line. There follows a Free Play, a magnificent combination, 9 - 10 - 12 with a sizzling inside ball to the winger. </br></br>Caught on the line, but retaining possession after a fierce battle at the ruck, the home side's second row crossed the line to score the first try of a game that started with a bang…</br></br>Equipped with a die and 22 cards numbered from 1 to 15, you will reproduce all the actions that make rugby our passion. From the simple run to the tackles, from the kicking game to the interception, from the mauls to the pick and go, from the ruck areas to the inevitable penalties, from the communication between the half-backs to the game combinations, the situations are countless.</br></br>Designed for players of all ages and levels, <span class='rwg'>Rugby World Game</span> is a certified experience, the result of hours of fun sharing our idea of rugby, a synthesis of emotions that addresses all rugby enthusiasts without particular distinctions, respectful of each other's differences and values."
            },

            Knowledge: {
                  title: "Basic knowledge",
                  desc: "Here the essentials are explained. It is strongly suggested to read it first."
            },

            Policy : {
                  title: "Privacy Policy",
                  desc: "Provided by Compagnie Blasco, the Rugby World Game app is intended for use as is. All data collected in the app will remain on the device it was created on, unless the user explicitly shared it themselves.</br></br>If you have any questions, please contact us by email at info@rugbyworldgame.com."
            },

            Results : {
                  title: "Games results",
                  desc: "Here are the lists of games shared by the community. We also use this list to decide between the best of us. Feel free to compete.",
            },

            Training : {
                  title: "Training camp",
                  desc: "Since practice is the key to success, check out the sections on this page, they contain scenarios that you should easily understand.",
            },

            Price : {
                  title: "It's not free",
                  desc: "<span class='rwg'>We made the choice to make this application paying for obvious reasons.</span></br></br>On the other hand, you won't find any advertisements and the application doesn't have an expiration date.</br></br>We also know that even if the price is relatively affordable, some people may have difficulties paying. If this is your case and you really want to join the community, contact us.",
            },

            URL: {
                  how: "how-to-play",
                  duration: "game-duration", 
                  pro_mode: "game-mode",
                  dices: "dices", 
                  cards: "cards", 
                  actions: "actions", 
                  hinge: "half-backs", 
                  starter: "first-passer", 
                  attributs: "attributes", 
                  combine: "playing-combinations", 
                  duel: "duel",
                  teams: "composition-of-the-team", 
                  keys: "keys-strength",
                  fouls: "fouls", 
                  twenty_two: "22-meter-area", 
                  bonus: "bonus", 
                  kickoff: "kickoff", 
                  counterattack: "counter-attack", 
                  tackle: "tackle", 
                  interception: "interception", 
                  free_play: "free-play",
                  ruck: "ruck", 
                  contest: "contest",
                  relay: "relay", 
                  pickandgo: "pick-and-go", 
                  no_contest: "no-contest",
                  lineout: "lineout", 
                  maul: "maul",
                  scrum: "scrum", 
                  knock_on: "knock-on", 
                  penalty: "penalty",
                  choice_hands: "quick-tap",
                  advantage: "back-to-penalty", 
                  choice_lineout: "penaltouch", 
                  run: "run", 
                  carry: "carry", 
                  kick: "kick", 
                  drop: "drop",  
                  try: "try", 
                  conversion: "conversion", 
                  find_lineout: "kick-for-touch",
                  twenty_two_drop_out: "22-drop-out",
                  offside: "offside"
            },

            Navigation: {
                  rules: "Game rules",
                  about: "About",
                  contact: "Contact us",
                  knowledge: "The basics",
                  results: "Results",
                  training: "Training camp"
            }
      }
}


